import React, { memo, useCallback, useMemo } from "react";
import { Card, Input, Controller, Button, SelectBox } from "components/src";
import { useTranslation } from "react-i18next";
import { FormProvider, useForm } from "react-hook-form";
import { Form, Switch, message } from "antd";
import { useGetAdminUsersList, useGetUserGetUserProfile, usePostChatAddNewGroup } from "core";

const TITLE = "title";
const PARTICIPANTS = "participants";
const ISMANDATORY = "isMandatory";

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 16 },
};

const AddGroup = memo(() => {
  const { i18n } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();
  const { data } = useGetAdminUsersList({ pageNumber: "1", pageSize: "400" });

  const methods = useForm({
    defaultValues: {
      title: "",
      participants: [],
      isMandatory: true
    },
  });

  const { data: { data: userData } = {}, isFetching } =
    useGetUserGetUserProfile({ refetchOnWindowFocus: false });

  const { handleSubmit, reset } = methods;

  const { mutate, isPending } = usePostChatAddNewGroup({
    onSuccess: () => {
      reset();
      messageApi.open({
        type: 'success',
        content: i18n.t('done'),
      });
    },
  });

  const onSubmit = useCallback(
    ({
      title,
      participants,
      isMandatory,
    }: {
      title: string;
      participants: string[];
      isMandatory: boolean;
    }) => {
      mutate({
        requestBody: {
          title,
          participants,
          isMandatory,
        },
      });
    },
    []
  );

  const options = useMemo((): any[] => {
    return data?.data?.users.map((item: any) => {
      return {
        value: item.userName,
        label: item?.nameAndFamily,
      };
    });
  }, [data]);

  return (
    <>
    {contextHolder}

      <Card title={i18n.t("addGroup")}>
        <FormProvider {...methods}>
          <Form
            {...layout}
            name="nest-messages"
            onFinish={handleSubmit(onSubmit)}
          >
            <Form.Item>
              <Controller rules={{ required: i18n.t('isRequired') }} name={TITLE}>
                <Input placeholder={i18n.t("title")} />
              </Controller>
            </Form.Item>

            <Form.Item>
              <Controller rules={{ required: i18n.t('isRequired') }} name={PARTICIPANTS}>
                 <SelectBox
                  mode="tags"
                  label={i18n.t("participants")}
                  placeholder={i18n.t("participants")}
                  options={options?.map((option) => ({
                    ...option,
                    disabled: option.value === userData?.userName,
                  }))}/>
              </Controller>
            </Form.Item>

            <Form.Item label={i18n.t("mandatory")}>
              <Controller name={ISMANDATORY}>
                <Switch />
              </Controller>
            </Form.Item>
            
            <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 5 }}>
              <Button
                style={{ width: "100px" }}
                type="primary"
                isLoading={isPending}
                htmlType="submit"
              >
                {i18n.t("done")}
              </Button>
            </Form.Item>

          </Form>
        </FormProvider>
      </Card>
    </>
  );
});
export { AddGroup };
